import { orderActionTypes } from "../../actionTypes/orders/order.actionTypes";

const initialState = {
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: null,
  },
  orders: [],
  selectedOrder: null,
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case orderActionTypes.START_ADD_ORDER:
    case orderActionTypes.START_UPDATE_ORDER:
    case orderActionTypes.START_DELETE_ORDER:
    case orderActionTypes.START_GET_ORDER_BY_ID:
    case orderActionTypes.START_GET_ORDERS:
    case orderActionTypes.START_UPDATE_ORDER_PAYMENT_SUCCESS:
      return setStateLoading(state);

    case orderActionTypes.ADD_ORDER_SUCCESS:
    case orderActionTypes.UPDATE_ORDER_SUCCESS:
    case orderActionTypes.UPDATE_ORDER_PAYMENT_SUCCESS:
      return setStateSuccess(state);

    case orderActionTypes.DELETE_ORDER_SUCCESS:
      return setStateSuccess(state);

    case orderActionTypes.GET_ORDER_BY_ID_SUCCESS:
      return setSelectedOrder(state, action);

    case orderActionTypes.GET_ORDERS_SUCCESS:
      return setOrders(state, action);

    case orderActionTypes.ADD_ORDER_FAILURE:
    case orderActionTypes.UPDATE_ORDER_FAILURE:
    case orderActionTypes.DELETE_ORDER_FAILURE:
    case orderActionTypes.GET_ORDER_BY_ID_FAILURE:
    case orderActionTypes.GET_ORDERS_FAILURE:
    case orderActionTypes.UPDATE_ORDER_PAYMENT_FAILURE:
      return setStateFailure(state, action);

    default:
      return state;
  }
};

const setStateLoading = (state) => ({
  ...state,
  stateInfo: {
    isLoading: true,
    isSuccess: false,
    isError: false,
    error: null,
  },
});

const setStateSuccess = (state) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
});

const setStateFailure = (state, action) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: true,
    error: action.error,
  },
});

const setOrders = (state, action) => ({
  ...state,
  orders: action.data,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
});

const setSelectedOrder = (state, action) => ({
  ...state,
  selectedOrder: action.data,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
});

export default orderReducer;
